import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'main' }
    }, {
      path: '/main',
      name: 'main',
      component: (resolve) => {
        require(['../pages/main/main.vue'], resolve)
      }
    }, {
      path: '/patient-intro',
      name: 'patient-intro',
      component: (resolve) => {
        require(['../pages/main/patientIntro.vue'], resolve)
      }
    }, {
      path: '/Andrew_Lin',
      name: 'Andrew_Lin',
      component: (resolve) => {
        require(['../pages/main/andrewLin.vue'], resolve)
      }
    }, {
      path: '*',
      redirect: { name: 'main' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js